import { render } from "./XMind.vue?vue&type=template&id=28b1cb02"
import script from "./XMind.vue?vue&type=script&lang=js"
export * from "./XMind.vue?vue&type=script&lang=js"

import "./XMind.vue?vue&type=style&index=0&id=28b1cb02&lang=css"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__